import fabric from '~/common/canvas/fabric';
import {
  DEFAULT_CARD_ZOOM,
  DEFAULT_HEIGHT_DESKTOP,
  DEFAULT_WIDTH_DESKTOP,
} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';

const calcCanvasRation = (cs, canvasWrapper, smallerScaleRatio) => {
  const paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
  const paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);

  const borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
  const borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);

  const containerWidth = canvasWrapper.offsetWidth - paddingX - borderX;
  const containerHeight = canvasWrapper.offsetHeight - paddingY - borderY;

  const flipCardBtnEl = document.querySelector('.flip-card__button'); // todo use smallerScaleRatio prop
  const useSmallerScale = smallerScaleRatio || flipCardBtnEl;
  const smallerRatioToUse = smallerScaleRatio ?? 0.9;

  const availableWidth = useSmallerScale ? containerWidth * smallerRatioToUse : containerWidth;
  const availableHeight = useSmallerScale ? containerHeight * smallerRatioToUse : containerHeight;

  const ratioHeight = availableWidth * 1.36;

  if (ratioHeight > availableHeight) {
    return {height: availableHeight, width: availableHeight / 1.36};
  }
  return {width: availableWidth, height: ratioHeight};
};

export const useCanvas = (
  canvasEl,
  configJson,
  callback,
  defaultDesktopHeight = DEFAULT_HEIGHT_DESKTOP,
  readOnly = false,
  smallerScaleRatio = null
) => {
  const canvasInstance = new fabric.Canvas(canvasEl, {
    width: DEFAULT_WIDTH_DESKTOP,
    height: defaultDesktopHeight,
    includeDefaultValues: false,
    preserveObjectStacking: true,
    selection: !evite.detects.isMobile,
    controlsAboveOverlay: true,
    allowTouchScrolling: true,
    skipTargetFind: readOnly,
  });

  canvasInstance.setZoom(DEFAULT_CARD_ZOOM);

  const setCurrentDimensions = (parentNode, canvasWrapperRef) => {
    const canvasSizer = document.getElementById(parentNode);
    const canvasWrapper = canvasSizer || canvasWrapperRef?.current;

    if (canvasWrapper && canvasInstance) {
      const cs = getComputedStyle(canvasWrapper);

      if (canvasWrapper.offsetWidth > 0 && canvasWrapper.offsetHeight > 0) {
        const {width, height} = calcCanvasRation(cs, canvasWrapper, smallerScaleRatio);
        const scale = width / canvasInstance.getWidth();
        const zoom = canvasInstance.getZoom() * scale;

        if (canvasInstance) {
          canvasInstance?.setDimensions({width, height});
          canvasInstance?.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);

          window.dispatchEvent(
            new CustomEvent('canvas:resized', {
              detail: {width, height},
            })
          );
        }
      }
    }
  };

  const loadCanvas = (jsonConfig) => {
    const reviver = (json, obj) => {
      const isUYOImage = obj.type === 'uYOImage';
      const isTextbox = obj.type === 'textbox';
      const controlsVisibility = {
        mtr: !isUYOImage,
        remove: !isUYOImage,
      };

      // eslint-disable-next-line no-param-reassign
      obj._originalObject =
        isUYOImage && obj._originalObject ? obj._originalObject : JSON.parse(JSON.stringify(obj));

      // eslint-disable-next-line no-param-reassign
      obj.selectable = (isTextbox || isUYOImage) && !readOnly;
      // eslint-disable-next-line no-param-reassign
      obj.evented = (isTextbox || isUYOImage) && !readOnly;

      if (isUYOImage && !obj.src) {
        obj.set({
          lockMovementX: true,
          lockMovementY: true,
          lockScalingX: true,
          lockScalingY: true,
          lockRotation: true,
        });
      }
      obj.setControlsVisibility(controlsVisibility);
      return obj;
    };
    if (canvasInstance && callback && jsonConfig)
      canvasInstance.loadFromJSON(jsonConfig, () => callback(canvasInstance), reviver);
  };

  if (configJson) {
    loadCanvas(configJson);
  }

  return {
    canvasInstance,
    setCurrentDimensions,
  };
};
